import { copy } from "../content/copy";
import { Link, usePath } from "../lib/router";
import { MotionToggle, SoundToggle } from "./Toggles";

export default function Nav() {
  const path = usePath();
  const onHome = path === "/";

  return (
    <nav className="nav">
      <Link className="nav-brand" to="/">
        {copy.hero.title}
      </Link>
      <div className="nav-right">
        <div className="nav-links">
          {onHome ? (
            <>
              <a href="#playground">{copy.nav.playground}</a>
              <a href="#lab">{copy.nav.lab}</a>
              <a href="#about">{copy.nav.about}</a>
            </>
          ) : (
            <Link to="/">← home</Link>
          )}
        </div>
        <div className="nav-actions">
          <SoundToggle />
          <MotionToggle />
        </div>
      </div>
    </nav>
  );
}
